<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <ClientsDropDownList
          :id="clientId"
          :isRequired="false"
          @clientIdChange="handleClientIdChange"
        ></ClientsDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <v-autocomplete
          v-model="employeeName"
          :items="employeesNames"
          item-text="name"
          label="Employee"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3" xl="2">
        <v-autocomplete
          v-model="jobTitle"
          :items="jobTitles"
          item-text="jobTitle"
          label="Job Title"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="2" xl="1">
        <YesNoDropDownList
          :active="isPaidInFull"
          label="Paid in Full"
          :clearable="true"
          @activeChange="handlePaidInFullChange"
        ></YesNoDropDownList>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { YesNoDropDownList } from '@/components/shared/yesNoLists'
import { ClientsDropDownList } from '@/components/clients'

export default {
  components: {
    FilterButtons,
    FilterButtonsSmall,
    YesNoDropDownList,
    ClientsDropDownList
  },
  props: [
    'employeesNames',
    'jobTitles'
  ],
  computed: {
    ...mapFields('directPlacementFilters', [
      'clientId',
      'employeeName',
      'jobTitle',
      'isPaidInFull'
    ])
  },
  methods: {
    ...mapActions('directPlacementFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleClientIdChange (value) {
      this.clientId = value
    },
    handlePaidInFullChange (newValue) {
      this.isPaidInFull = newValue
    },
    handleClearClick () {
      this.clearFilters()
      this.$emit('clear')
    }
  }
}
</script>
